require('./paging');

var MODULE_NAME = 'ui.bootstrap.module.paging';

angular.module(MODULE_NAME, ['ui.bootstrap.paging']);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/paging/index.js
// module id = 567
// module chunks = 0